import React, { useId } from 'react';
import { Box, GridLegacy as Grid, Card, CardContent, CircularProgress } from '@mui/material';

export const BusyIndeterminate = () => {
  const labelId = useId();
  return (
    <Grid item xs={12}>
      <Card>
        <CardContent sx={{ textAlign: 'center' }}>
          <CircularProgress size={72} sx={{ mb: 3 }} aria-labelledby={labelId} />
          <div id={labelId}>Just a moment...</div>
        </CardContent>
      </Card>
    </Grid>
  );
};

type BusyIndeterminateInlineProps = {
  justify?: string;
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'inherit';
  height?: string;
};

export const BusyIndeterminateInline = ({ justify, color, height }: BusyIndeterminateInlineProps) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: justify || 'flex-start', height: height || '1.5em' }}>
      <CircularProgress color={color || 'primary'} size={20} />
    </Box>
  );
};

type BusyIndeterminateMiniProps = {
  altSize?: number;
  label?: string;
};

export const BusyIndeterminateMini = ({ altSize, label = 'Loading' }: BusyIndeterminateMiniProps) => {
  return <CircularProgress size={altSize || 40} sx={{ mx: 'auto' }} aria-label={label} />;
};
